import { Dispatch } from "@reduxjs/toolkit";
import {
  ChallengeAttempt,
  ChallengeHistory,
  DailyChallenge,
} from "../../types/challenges";
import { ThunkActionType } from "../store";
import { fetchWrapper } from "./fetchWrapper";

export type ChallengesActionTypes =
  | SetChallengesLoading
  | SetDailyChallenge
  | SetChallengeStats;
export interface SetChallengesLoading {
  type: "SET_CHALLENGES_LOADING";
  payload: {
    loading: boolean;
  };
}
export interface SetDailyChallenge {
  type: "SET_DAILY_CHALLENGE";
  payload: {
    challenge: DailyChallenge;
    myAttempt?: ChallengeAttempt;
  };
}
export interface SetChallengeStats {
  type: "SET_CHALLENGE_STATS";
  payload: {
    stats?: ChallengeHistory;
  };
}
export const setChallengesLoading = (
  loading: boolean
): SetChallengesLoading => ({
  type: "SET_CHALLENGES_LOADING",
  payload: {
    loading,
  },
});
export const setChallengeStats = (
  stats?: ChallengeHistory
): SetChallengeStats => ({
  type: "SET_CHALLENGE_STATS",
  payload: {
    stats,
  },
});

export const getDailyChallenge = (day: string): ThunkActionType => {
  return async (dispatch: Dispatch<ChallengesActionTypes>) => {
    dispatch(setChallengesLoading(true));
    const result = await fetchWrapper(
      dispatch,
      "GET",
      `challenges/getchallenge/${day}`
    );
    dispatch(setChallengesLoading(false));
    if (result.returnCode === 0) {
      dispatch({
        type: "SET_DAILY_CHALLENGE",
        payload: {
          challenge: result.responseMessage.challenge,
          myAttempt: result.responseMessage.myAttempt,
        },
      });
    }
  };
};

export const getChallengeStats = (): ThunkActionType => {
  return async (dispatch: Dispatch<ChallengesActionTypes>) => {
    dispatch(setChallengesLoading(true));
    const result = await fetchWrapper(
      dispatch,
      "GET",
      "challenges/mychallenges"
    );
    dispatch(setChallengesLoading(false));
    if (result.returnCode === 0) {
      dispatch(setChallengeStats(result.responseMessage));
    }
  };
};

export const submitChallengeAttempt = (
  attempt: ChallengeAttempt
): ThunkActionType => {
  return async (dispatch: Dispatch<ChallengesActionTypes>) => {
    dispatch(setChallengesLoading(true));
    const result = await fetchWrapper(
      dispatch,
      "POST",
      "challenges/recordattempt"
    );
    dispatch(setChallengesLoading(false));
    if (result.returnCode === 0) {
      dispatch(setChallengeStats(undefined));
    }
  };
};
